import styled from "styled-components";
// import {palette} from 'styled-theme'

export const ImageGalleryWrapper = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  box-sizing: border-box;
  .image-gallery,
  .image-gallery-slide-wrapper,
  .image-gallery-swipe,
  .image-gallery-slides {
    width: 100%;
    max-width: 100%;
    overflow: hidden;
  }
  .image-gallery-slide img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }
  .image-gallery-thumbnails-wrapper {
    margin-top: 12px;
    overflow: hidden;
  }
  .image-gallery-thumbnails .image-gallery-thumbnails-container {
    display: flex;
    gap: 8px;
    justify-content: space-between;
  }
  .image-gallery-thumbnail {
    width: calc((100% - 24px) / 4);
    border: none;
    border-radius: 8px;
    overflow: hidden;
  }
  .image-gallery-thumbnail img {
    width: 100%;
    height: 64px;
    object-fit: cover;
  }
  .image-gallery-thumbnail.active,
  .image-gallery-thumbnail:focus,
  .image-gallery-thumbnail:hover {
    border: 2px solid #3b82f6;
  }
  .image-gallery-svg {
    height: 50px;
    width: 20px;
  }

  @media (max-width: 600px) {
    max-width: 100%;
    .image-gallery-slide,
    .image-gallery-center {
      max-height: 240px;
    }
    .image-gallery-slide img {
      max-height: 240px;
      object-fit: cover;
    }
    .image-gallery-thumbnail img {
      height: 52px;
    }
  }
`;
